/**
 * @name isInternetExplorer
 *
 * @description Function returns true when browser is Internet Explorer
 *
 * @example
 * import { isInternetExplorer } from '@workbench/core';
 *
 * if (isInternetExplorer()) {
 *   // run IE fallback...
 * }
 */
function isInternetExplorer() {
  return window.navigator.userAgent.indexOf('MSIE ') > 0 || Boolean(navigator.userAgent.match(/Trident.*rv:11\./));
}

export { isInternetExplorer as i };
